import React from 'react'

import './content-box.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'section'>,
  {
    children: React.ReactNode
  }
>

const ContentBox = ({className, children, ...props}: Props) => (
  <section {...props} className={cn('ContentBox', {}, className)}>
    {children}
  </section>
)

export default ContentBox
